module.exports = __webpack_public_path__ + "static/media/idx.9dd5839b.png";